/* eslint-disable i18n-scan/no-inline-content */
import { Search, AlgoliaSearch } from '@paypalcorp/developersearchui'
import React, { useEffect, useState } from 'react'
import {
  IconChevron,
  LoggedNav,
  LoginButton,
  MenuIcon,
  MobileMenu,
  PPColor,
  Sidenav,
  TopNav,
  TopNavLogo,
  ExternalLink,
} from '../common'
import {
  loggedNavMenuItems,
  mobileMenuContent,
  mobileUserMenuContent,
  sidenavNavigation,
  mainButtonLinks,
  mainNavigationBlue,
} from '../../config'
import { useWindowSize } from '../../hooks'
import { useApplicationContext } from '../../context/ApplicationContext'
import { Message } from '@paypalcorp/worldready-react'
import constant from '../../common/constant'
import { ELMO_EXPERIMENTS } from '../../constants'
import { isAlgoliaSearch } from '../../utils/algoliaUtils'
// eslint-disable-next-line complexity
export const MainNav = ({ pathname }) => {
  const {
    user,
    logoutUrl,
    webLLSLogoutUrl,
    isWebLLSUser,
    contextualLoginUrl,
    enviroment,
    aiSearch,
    aiSearch_acctID,
    upgradehub_v2,
  } = useApplicationContext()

  const showAlgoliaSearch = isAlgoliaSearch(aiSearch, aiSearch_acctID)

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [activeMenu, setActiveMenu] = useState('')
  const [activeTab, setActiveTab] = useState('')
  const [cursor, setCursor] = useState(null)
  const [isSidenavOpen, setIsSidenavOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [currentMainButtonLinks, setCurrentMainButtonLinks] =
    useState(mainButtonLinks)
  const windowSize = useWindowSize()
  const isDesktop = windowSize.width > 1200
  const getMenuItem = () => {
    const activeButtonObj = currentMainButtonLinks.filter((a) =>
      a.menuItems?.find(
        (item) => item?.path?.replace('ENVIRONMENT', enviroment) === pathname,
      ),
    )[0]
    return activeButtonObj?.menuItems?.find(
      (item) => item?.path?.replace('ENVIRONMENT', enviroment) === pathname,
    )
  }

  const isUpgradeHubActive =
    upgradehub_v2 === ELMO_EXPERIMENTS.UpgradeHub.Treatment

  useEffect(() => {
    if (!isMenuOpen) {
      setCursor(null)
    }

    setCurrentMainButtonLinks(
      enviroment === 'sandbox'
        ? mainButtonLinks.map((item) => ({
            ...item,
            menuItems: item.menuItems?.filter(
              (child) => child.title !== 'Transactions',
            ),
          }))
        : mainButtonLinks,
    )

    let activeButtonObj = currentMainButtonLinks.find((buttonObj) => {
      const path = buttonObj.path?.replace('ENVIRONMENT', enviroment)
      if (path === pathname) {
        return path
      }
      return ''
    })

    let activeMenuItem = getMenuItem()
    if (activeButtonObj) {
      setActiveTab(activeButtonObj.title)
    } else if (activeMenuItem) {
      setActiveTab(activeMenuItem.parentTitle)
    } else {
      setActiveTab('')
    }
    return () => {
      activeButtonObj = {}
      activeMenuItem = {}
    }
  }, [isMenuOpen, pathname, enviroment])

  const handleShowMenu = (title) => setActiveMenu(title)
  const handleHideMenu = () => setActiveMenu('')
  const handleActiveTab = (title, itemPath, hasParent = false) => {
    if (itemPath === pathname || hasParent) {
      setActiveTab(title)
    }
  }

  const host =
    constant.ENVIRONMENT.PRODUCTION === process.env.NODE_ENV
      ? constant.HOST_NAME.LIVE
      : constant.HOST_NAME.MSM

  return (
    <>
      <TopNav>
        {isDesktop && user && !isWebLLSUser && (
          <LoggedNav
            currentUser={user}
            profileMenuItems={[
              ...loggedNavMenuItems,
              { title: 'Log Out', path: logoutUrl, target: '_self' },
            ]}
            menuList={mainNavigationBlue}
            key="logged-nav-1"
          />
        )}
        {isDesktop && user && isWebLLSUser && (
          <LoggedNav
            currentUser={user}
            profileMenuItems={[
              { title: 'Switch User', path: webLLSLogoutUrl, target: '_self' },
              ...loggedNavMenuItems,
              { title: 'Log Out', path: logoutUrl, target: '_self' },
            ]}
            menuList={mainNavigationBlue}
            key="logged-nav-2"
          />
        )}

        <TopNav.Container>
          <TopNav.Row key="top-nav-row">
            {isDesktop ? (
              <>
                <TopNav.Column style={{ flexGrow: '4' }} key="top-nav-column">
                  <ExternalLink
                    href="https://developer.paypal.com/home"
                    target="_self"
                    className="top-nav-pp-home-icon"
                  >
                    <TopNavLogo style={{ width: '11rem', display: 'block' }} />
                  </ExternalLink>

                  <TopNav.ItemsContainer key="top-nav-item-container">
                    {currentMainButtonLinks?.map((item, idx) => {
                      if (item.title === 'Upgrade' && !isUpgradeHubActive) {
                        return null
                      }

                      const itemPath = item.path?.replace('ENVIRONMENT', enviroment)
                      const isActive = activeTab === item.title
                      const hasMenu = !!item.menuItems
                      const menuIsOpen = activeMenu === item.title

                      const handleItemKeyDown = (e) => {
                        if (e.key === 'Enter') {
                          setActiveMenu((prev) => (prev !== item.title ? item.title : ''))
                        }
                      }

                      return (
                        <TopNav.ItemContainer
                          key={idx}
                          className="dev_dash__main-nav__item--container"
                          onMouseEnter={() => handleShowMenu(item.title)}
                          onMouseLeave={handleHideMenu}
                          onFocus={() => setIsMenuOpen(true)}
                          onBlur={() => setIsMenuOpen(false)}
                          onKeyDown={handleItemKeyDown}
                        >
                          <div>
                            <TopNav.Item
                              key={'item' + idx}
                              hasPath={!!item.path}
                              secondary
                              to={itemPath}
                              tabIndex={0}
                              onFocus={() => setIsMenuOpen(true)}
                              onClick={() => handleActiveTab(item.title, itemPath)}
                              className={isActive ? 'dev_dash__top-nav_active' : ''}
                            >
                              {item.title}
                            </TopNav.Item>

                            {hasMenu && (
                              <TopNav.Menu
                                key={'topMenu' + idx}
                                className={`${
                                  menuIsOpen
                                    ? 'dev_dash__main-nav--dropdown_content--open'
                                    : ''
                                } dev_dash__main-nav--dropdown_content`}
                              >
                                {item.menuItems.map((menuItem) =>
                                  renderMenuItem({
                                    menuItem,
                                    idx,
                                    enviroment,
                                    cursor,
                                    host,
                                    handleShowMenu,
                                    handleActiveTab,
                                  })
                                )}
                              </TopNav.Menu>
                            )}
                          </div>
                        </TopNav.ItemContainer>
                      )
                    })}
                  </TopNav.ItemsContainer>
                </TopNav.Column>
                <TopNav.Column
                  align="left"
                  justify="left"
                  key="top-nav-column-2"
                >
                  {!user ? (
                    <div style={{ width: '100%' }}>
                      <div className="dev_dash__top-nav-switcher-flex">
                        <LoginButton
                          onClick={() => {
                            window.location.href = contextualLoginUrl
                          }}
                          data-dxa="login,nav-click,nav-login"
                        >
                          <Message id="home.loginBtn.title" />
                        </LoginButton>
                      </div>
                    </div>
                  ) : (
                    <TopNav.TopNavToggle key="top-nav-toggle" />
                  )}
                </TopNav.Column>
              </>
            ) : (
              <>
                <TopNav.Column justify="flex-start">
                  <span
                    style={{ width: 'auto', height: '2rem' }}
                    onClick={() =>
                      setIsSidenavOpen((prev) => {
                        setIsMobileMenuOpen(false)
                        return !prev
                      })
                    }
                  >
                    <IconChevron
                      displayDirection={isSidenavOpen ? 'up' : 'down'}
                      style={{
                        width: 'auto',
                        height: '2rem',
                        cursor: 'pointer',
                      }}
                    />
                  </span>
                </TopNav.Column>
                {isSidenavOpen && (
                  <div className="dev_dash__main-nav--sidenav__container">
                    <Sidenav style={{ height: '100vh' }}>
                      <Sidenav.Body>
                        {sidenavNavigation.map((nav, idx) => (
                          <React.Fragment key={`${nav.sectionTitle}-${idx}`}>
                            <Sidenav.Section title={nav.sectionTitle}>
                              {nav.items &&
                                nav.items.map((item, _idx) => (
                                  <Sidenav.Item
                                    key={`${item.title}-${_idx}`}
                                    currentPath={item.path?.replace(
                                      'ENVIRONMENT',
                                      enviroment,
                                    )}
                                    onClick={() => setIsSidenavOpen(false)}
                                  >
                                    <Sidenav.Link
                                      to={item.path?.replace(
                                        'ENVIRONMENT',
                                        enviroment,
                                      )}
                                      as={item.external ? 'a' : null}
                                      href={
                                        item.external
                                          ? item.path?.replace(
                                              'ENVIRONMENT',
                                              enviroment,
                                            )
                                          : null
                                      }
                                    >
                                      {item.title}
                                    </Sidenav.Link>
                                  </Sidenav.Item>
                                ))}
                            </Sidenav.Section>
                          </React.Fragment>
                        ))}
                      </Sidenav.Body>
                    </Sidenav>
                  </div>
                )}
                <TopNav.Column justify="center">
                  <span style={{ width: '2rem', height: '2rem' }}>
                    <PPColor />
                  </span>
                </TopNav.Column>
                <TopNav.Column justify="flex-end">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {!showAlgoliaSearch ? (
                      <Search
                        isSecondary={false}
                        searchBtnStyles={'logged__nav--search-button'}
                        component={'devdashnodeweb'}
                        clientFptiProps={{
                          space_key: 'SKEXJE',
                        }}
                      />
                    ) : (
                      <AlgoliaSearch
                        buttonStyle={{
                          isSecondary: true,
                          size: 'sm',
                          isInverse: true,
                        }}
                        fptiOptions={{
                          space_key: 'SKEXJE',
                          component: 'devdashnodeweb',
                        }}
                      />
                    )}
                    <MenuIcon
                      style={{ marginLeft: '0.5rem', cursor: 'pointer' }}
                      onClick={() => {
                        setIsSidenavOpen(false)
                        setIsMobileMenuOpen((prev) => !prev)
                      }}
                      isOpen={isMobileMenuOpen}
                    />
                  </div>
                </TopNav.Column>
                {isMobileMenuOpen && !isWebLLSUser && (
                  <MobileMenu
                    menuContent={mobileMenuContent}
                    userMenuContent={[
                      ...mobileUserMenuContent,
                      { title: 'Log Out', path: logoutUrl },
                    ]}
                    currentUser={user}
                    onClose={() => setIsMobileMenuOpen(false)}
                    setLogin={() => {
                      window.location.href = contextualLoginUrl
                    }}
                  />
                )}
                {isMobileMenuOpen && isWebLLSUser && (
                  <MobileMenu
                    menuContent={mobileMenuContent}
                    userMenuContent={[
                      { title: 'Switch User', path: webLLSLogoutUrl },
                      ...mobileUserMenuContent,
                      { title: 'Log Out', path: logoutUrl },
                    ]}
                    currentUser={user}
                    onClose={() => setIsMobileMenuOpen(false)}
                    setLogin={() => {
                      window.location.href = contextualLoginUrl
                    }}
                  />
                )}
              </>
            )}
          </TopNav.Row>
        </TopNav.Container>
      </TopNav>
    </>
  )
}

// Helper function outside the map
function renderMenuItem({
  menuItem,
  idx,
  enviroment,
  cursor,
  host,
  handleShowMenu,
  handleActiveTab,
}) {
  const isExternal = menuItem.externalLink
  const menuItemPath = menuItem.path?.replace('ENVIRONMENT', enviroment)
  const isMenuItemActive = menuItem.title.trim() === cursor
  const key = `topMenuItem${idx}${menuItem.title.trim()}`

  return (
    <TopNav.MenuItem
      as={isExternal ? 'a' : 'NavLink'}
      to={menuItemPath}
      active={isMenuItemActive}
      key={key}
      onClick={() => {
        handleShowMenu(menuItem.path)
        handleActiveTab(menuItem.parentTitle, menuItem.path, true)
      }}
      target={isExternal ? '_blank' : '_self'}
      href={
        isExternal
          ? `${host}${menuItem.externalLink}`
          : undefined
      }
    >
      {menuItem.title}
    </TopNav.MenuItem>
  )
}
